import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { generateFileName } from "../../utils/utility";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { makeStyles } from "@material-ui/core/styles";
import { upload } from "../../service/api/common";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  profile: {
    borderRadius: "50%",
    backgroundColor: "white",
    width: 200,
    height: 200,
    marginBottom: 20,
    textAlign: "center",
    overflow: "hidden",
  },
  formItem: {
    marginBottom: 20,
  },
  button: {
    marginBottom: 20,
    width: 200,
  },
  img: {
    width: 200,
    height: 200,
    objectFit: "cover",
  },
  imgIcon: {
    width: 200,
    height: 200,
  },
  errorText: {
    color: "red",
  },
  progress: {
    marginLeft: 5,
  },
});

const ProfilePicker = ({ value, setValue }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(false);
  const classes = useStyles();

  const handleUpload = async (file) => {
    if (!file) return;
    // clear old url
    setValue("");
    setUploading(true);
    const fileType = file.type.split("/")[0];
    const newFileName = await generateFileName(file);
    const myRenamedFile = new File([file], newFileName);

    upload(fileType, myRenamedFile)
      .then(() => {
        setValue(
          `${process.env.REACT_APP_API_URL}/static?path=${fileType}/${newFileName}`
        );
        setUploading(false);
      })
      .catch((err) => {
        console.log(err);
        setUploading(false);
        setError(true);
      });
  };

  return (
    <div className={classes.root}>
      <div className={classes.profile}>
        {value ? (
          <img src={value} alt={"Profile"} className={classes.img} />
        ) : (
          <AccountCircleIcon className={classes.imgIcon} />
        )}
      </div>

      {error ? (
        <div className={classes.errorText}>
          File upload failed, please try again.
        </div>
      ) : null}
      <Button
        variant="contained"
        color="primary"
        component="label"
        className={classes.button}
        disabled={uploading}
      >
        Upload Profile
        {uploading ? <CircularProgress className={classes.progress} /> : null}
        <input
          type="file"
          style={{ display: "none" }}
          accept="image/*"
          onChange={(e) => {
            setError(false);
            if (e.target.files.length > 0) {
              // TODO: Handle upload only when form is saved
              handleUpload(e.target.files[0]);
            }
          }}
        />
      </Button>
      {!!value && value.length > 0 ? (
        <Button
          variant="contained"
          onClick={() => {
            setValue("");
          }}
          className={classes.button}
          color="secondary"
        >
          Remove Profile
        </Button>
      ) : null}
    </div>
  );
};

export default ProfilePicker;
